export default "__VITE_ASSET__DItIkOyp__"